export const CONST = 'const';
export const MAX_CARD_TEXT_LENGHT = 150;

export const BRNO = 'brno';
export const PRAGA = 'praga';
export const OLOMUNIEC = 'olomouc';
export const OSTRAWA = 'ostrawa';
export const KRAKOW = 'krakow';


export const SAJ_LOCATIONS = [ PRAGA, OLOMUNIEC, OSTRAWA, KRAKOW, BRNO ] as const;


export const INSTAGRAM_LINK = 'https://www.instagram.com/sekcja_akademicka_jednosc/';
export const PZKO_LINK = 'https://www.pzko.cz/';
export const SMP_LINK = 'https://smprc.cz/';
